import React, { useState } from "react";
import { auth, signInWithEmailAndPassword, signInWithPhoneNumber, RecaptchaVerifier } from "./firebaseConfig";
import { useNavigate } from "react-router-dom";

function Login() {
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [verificationId, setVerificationId] = useState(null);
  const navigate = useNavigate();

  // Initialize reCAPTCHA
  const setupRecaptcha = () => {
    window.recaptchaVerifier = new RecaptchaVerifier(auth, "recaptcha-container", {
      size: "invisible",
    });
  };

  // Handle phone login with OTP
  const sendOTP = async () => {
    setupRecaptcha();
    const phoneNumber = `+1${phone}`;
    try {
      const confirmation = await signInWithPhoneNumber(auth, phoneNumber, window.recaptchaVerifier);
      setVerificationId(confirmation.verificationId);
      alert("OTP sent to your phone!");
    } catch (error) {
      console.error("Error sending OTP:", error);
    }
  };

  const verifyOTP = async () => {
    try {
      const credential = auth.PhoneAuthProvider.credential(verificationId, otp);
      await auth.signInWithCredential(credential);
      alert("Login successful!");
      navigate("/");
    } catch (error) {
      console.error("Error verifying OTP:", error);
    }
  };

  // Handle email/password login
  const handleLogin = async () => {
    try {
      await signInWithEmailAndPassword(auth, email, password);
      alert("Login successful!");
      navigate("/");
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  return (
    <div className="login-container">
      <h2>Login</h2>

      {/* Phone Login */}
      <input 
        type="text" 
        placeholder="Phone (e.g., 8579191383)" 
        value={phone} 
        onChange={(e) => setPhone(e.target.value)} 
      />
      <button onClick={sendOTP}>Send OTP</button>

      {verificationId && (
        <>
          <input 
            type="text" 
            placeholder="Enter OTP" 
            value={otp} 
            onChange={(e) => setOtp(e.target.value)} 
          />
          <button onClick={verifyOTP}>Verify OTP</button>
        </>
      )}

      <h3>OR</h3>

      {/* Email Login */}
      <input 
        type="email" 
        placeholder="Email (e.g., example@mail.com)" 
        value={email} 
        onChange={(e) => setEmail(e.target.value)} 
      />

      <input 
        type="password" 
        placeholder="Password" 
        value={password} 
        onChange={(e) => setPassword(e.target.value)} 
      />

      <button onClick={handleLogin}>Login</button>

      <p>Don't have an account? <a href="/signup">Sign up here</a></p>

      {/* reCAPTCHA container */}
      <div id="recaptcha-container"></div>
    </div>
  );
}

export default Login;